<div class="bg-blue-800 text-white text-left px-8 py-16 text-3xl rounded-b-md">
  Rapport visite
</div>
<div class="flex" style="height: 90%">
  <div class="block w-1/5 border-r">
    <div class="p-10">
      <div>
        <unilog-recherche
          appearance="outline"
          [(ngModel)]="rep"
          champsModel="Tiers_code"
          champsAffiche="Tiers_RS"
          [ServerSideFiltering]="true"
          textErreur="Veuillez Entrer un tier valide"
          [showError]="true"
          recherche="API_ListeRep"
          [api]="generalService.api"
          placeholder="Nom"
        >
        </unilog-recherche>
      </div>
      <div>
        <unilog-recherche
          [(ngModel)]="client"
          appearance="outline"
          champsModel="Tiers_code"
          champsAffiche="Tiers_RS"
          [ServerSideFiltering]="true"
          textErreur="Veuillez Entrer un tier valide"
          [showError]="true"
          recherche="Tier"
          [api]="generalService.api"
          placeholder="Client"
        >
        </unilog-recherche>
      </div>
      <div>
        <mat-form-field appearance="outline" style="display: block !important">
          <mat-label>Date min</mat-label>
          <input
            matInput
            [(ngModel)]="dateMin"
            [matDatepicker]="picker1"
            placeholder="Date min"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" style="display: block !important">
          <mat-label>Date max</mat-label>
          <input
            matInput
            [(ngModel)]="dateMax"
            [matDatepicker]="picker2"
            placeholder="Date max"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>
      <button
        (click)="search()"
        class="bg-blue-500 text-white w-full"
        mat-flat-button
      >
        Rechercher <mat-icon>search</mat-icon>
      </button>
    </div>
    <hr class="my-8" />
    <div class="text-gray-700 text-2xl px-8 font-bold">Liste des rapports</div>
    <div *ngFor="let rapport of listRaport" (click)="selectRapport(rapport)">
      <div
        (click)="selectedRapport = rapport.CRMActivity_Id"
        class="p-8 border-b flex justify-between"
        [class]="
          rapport.CRMActivity_Id == selectedRapport
            ? 'bg-blue-500 text-white'
            : 'text-gray-700'
        "
      >
        <span>{{ rapport.CRMActivity_Titre }}</span>
        <span class="font-bold">{{
          rapport.CRMActivity_Date | date: "dd-MM-YYYY"
        }}</span>
      </div>
    </div>
  </div>

  <div class="flex justify-center w-4/5 p-10 bg-gray-100" *ngIf="raportDetails">
    <div
      class="rounded-md shadow-md p-16 w-10/12 flex flex-col gap-2 border bg-white"
    >
      <div class="text-3xl text-center">
        {{ raportDetails.CRMActivity_Titre }}
      </div>
      <div class="flex justify-between">
        <div class="">
          <div class="grid">
            <div>Date visite :</div>
            <div class="font-bold">
              {{ raportDetails.CRMActivity_Date | date: "dd-MM-YYYY" }}
            </div>
          </div>
          <div class="grid">
            <div>Nom client :</div>
            <div class="font-bold">{{ raportDetails.Tiers_RS }}</div>
          </div>
          <div class="grid">
            <div>Adresse :</div>
            <div class="font-bold">{{ raportDetails.Tiers_Adresse }}</div>
          </div>
          <div class="grid">
            <div>Ville :</div>
            <div class="font-bold">{{ raportDetails.Tiers_Ville }}</div>
          </div>
        </div>
        <div>
          <circle-progress
            [percent]="raportDetails.XCRMActivity_TauxAvancement"
            [radius]="40"
            [space]="-7"
            [outerStrokeWidth]="7"
            [innerStrokeWidth]="7"
            [outerStrokeColor]="'#6eb300'"
            [outerStrokeGradientStopColor]="'#3c9202'"
            [animation]="true"
            [animationDuration]="300"
            [innerStrokeColor]="'#e7e8ea'"
          ></circle-progress>
        </div>
      </div>
      <hr class="my-4" />
      <div class="flex justify-between mr-5">
        <div class="grid">
          <div>Contact :</div>
          <div class="font-bold">{{ raportDetails.Tiers_Contact_Nom }}</div>
        </div>
        <div class="grid">
          <div>Email :</div>
          <div class="font-bold">{{ raportDetails.Tiers_Contact_mail }}</div>
        </div>
        <div class="grid">
          <div>Tél :</div>
          <div class="font-bold">{{ raportDetails.Tiers_Contact_Tel }}</div>
        </div>
      </div>
      <hr class="my-4" />
      <!-- <div class="grid">
        <div>Position (personne qui a le contacter) :</div>
        <div class="font-bold"></div>
      </div> -->
      <div class="grid">
        <div>Potentiel client :</div>
        <div class="font-bold">{{ raportDetails.XCRMActivity_Potentiel }}</div>
      </div>
      <div class="grid">
        <div>Gamme vendue :</div>
        <div class="font-bold">
          {{ raportDetails.XCRMActivity_GammeVendue }}
        </div>
      </div>
      <div class="grid">
        <div>Concurrents présents :</div>
        <div class="font-bold">
          {{ raportDetails.XCRMActivity_Concurrents }}
        </div>
      </div>
      <div class="grid">
        <div>Potentiel par catégorie située :</div>
        <div class="font-bold">
          {{ raportDetails.XCRMActivity_Potentielparcat }}
        </div>
      </div>
      <div class="grid">
        <div>Gamme proposée :</div>
        <div class="font-bold">{{ raportDetails.XCRMActivity_Gammeprop }}</div>
      </div>
      <div class="grid">
        <div>Gamme vendue :</div>
        <div class="font-bold">
          {{ raportDetails.XCRMActivity_GammeVendue }}
        </div>
      </div>
      <div class="grid">
        <div>Feedback visite :</div>
        <div class="font-bold">{{ raportDetails.XCRMActivity_feedback }}</div>
      </div>
      <div class="grid">
        <div>Prochaine étape :</div>
        <div class="font-bold">
          {{ raportDetails.XCRMActivity_Prochaineetape }}
        </div>
      </div>
    </div>
  </div>
</div>
